import SolutionBreadcrumb from "./SolutionBreadcrumb";

export default SolutionBreadcrumb;



// WEBPACK FOOTER //
// ./js/components/SolutionBreadcrumb/index.js